import "./Team.style.scss";
import SubHeading from "../SubHeading/SubHeading";
import { ourTeamImages } from "../../constants/data";
import "react-lazy-load-image-component/src/effects/blur.css";
import useTranslate from "../../hooks/useTranslate";
import i18next from "i18next";

const Team = () => {
  const { translate } = useTranslate();

  return (
    <div className="app__team flex__center section__padding">
      <SubHeading
        title={translate("title.team")}
        color="#0c0c0c"
        description={""}
        kind={""}
        spoonColor={"black"}
      />
      <div className="app__team-grid">
        {ourTeamImages.map((image, index) => (
          <div key={index} className="app__team-grid__card">
            <div className="app__team-grid__card-img">
              <img src={image.image} alt={image.personName} />
            </div>
            <h3
              className={`app__team-grid__card-name p__cormorant ${i18next.language}`}
            >
              {translate(image.personName)}
            </h3>
            <p className="app__team-grid__card-role p__openSans">
              {translate(image.job)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
